import { translate as t } from '@thoughtspot/i18n';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { FormBuilder } from '@thoughtspot/radiant-react/widgets/form-builder';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import React, { useRef } from 'react';
import { Title } from '../../settings/setting/title';
import styles from './chart-customization-settings.module.scss';
import { NEW_CHARTS_DEFAULT_FIELD_ID, TranslationKeys } from './settings.constants';
import { buildToggleField } from './settings.field';
export const SettingsEdit = ({ enabled, saving, onSave, onCancel, }) => {
    const formBuilderRef = useRef(null);
    const handleSave = () => {
        const fields = formBuilderRef.current?.onSubmitForm();
        const field = fields?.find(f => f.id === NEW_CHARTS_DEFAULT_FIELD_ID);
        const next = field ? String(field.value) === 'true' : enabled;
        onSave(next);
    };
    return (React.createElement("div", { className: styles.settingsContainer },
        React.createElement(Title, { settingTitle: t(TranslationKeys.SETTINGS_HEADER), actions: [], actionHandler: () => undefined, titleSize: "large" }),
        React.createElement(Vertical, null,
            React.createElement(FormBuilder, { ref: formBuilderRef, itemLayout: "horizontal", formFields: [buildToggleField(enabled)], viewMode: "edit" })),
        React.createElement("div", { className: styles.editActions },
            React.createElement(Button, { text: t(TranslationKeys.SAVE_ACTION), onClick: handleSave, isDisabled: saving }),
            React.createElement(Button, { text: t(TranslationKeys.CANCEL_ACTION), type: "secondary", onClick: onCancel, isDisabled: saving }))));
};
//# sourceMappingURL=settings-edit.js.map